import Logo from 'v3/components/Logo';
import {
  LinkedinIn,
  FacebookF,
  Youtube,
  Instagram,
} from '@styled-icons/fa-brands';

import * as S from './styles';

export type FooterTypes = {
  linkedin?: string;
  facebook?: string;
  youtube?: string;
  instagram?: string;
  copyTag?: React.ElementType;
};

const Footer = ({
  linkedin,
  facebook,
  youtube,
  instagram,
  copyTag,
}: FooterTypes) => (
  <S.Wrapper>
    <S.Container>
      <S.LinksRow>
        <S.LogoSection>
          <a aria-label="savings.club website" href=" https://savings.club">
            <Logo variant="secondary" />
          </a>
          <S.LogoText>Smart funding for smart people.</S.LogoText>
        </S.LogoSection>

        <S.SocialSection>
          {linkedin && (
            <a
              href={linkedin}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Linkedin"
            >
              <LinkedinIn size={25} />
            </a>
          )}

          {facebook && (
            <a
              href={facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FacebookF size={24} />
            </a>
          )}

          {youtube && (
            <a
              href={youtube}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Youtube"
            >
              <Youtube size={26} />
            </a>
          )}

          {instagram && (
            <a
              href={instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <Instagram size={26} />
            </a>
          )}
        </S.SocialSection>
      </S.LinksRow>
      <S.CopySection>
        <S.CopyText as={copyTag}>
          Copyright © {new Date().getFullYear()} Saving’s Club | All rights
          reserved.
        </S.CopyText>
      </S.CopySection>
    </S.Container>
  </S.Wrapper>
);

export default Footer;
